import { message } from 'antd';
import * as API from '@/services/api';

export default {
  namespace: 'term',
  state: {
    termList: [],
    termParams: {},
    termPagination: {},
    term_example: ''
  },
  effects: {
    *getTermList({ payload }, { call, put, select }) {
      const params = yield select((state) => state.term.termParams);
      const res = yield call(API.getTermList, { ...params, ...payload });
      if (res.code === 0) {
        const data = res.data;
        yield put({
          type: 'save',
          payload: {
            termList: data.data,
            termParams: { ...params, ...payload },
            termPagination: data.pagination,
            term_example: data.term_example
          },
        });
      }
    },

    *addTerm({ payload }, { call, put }) {
      yield put({
        type: 'save',
        payload: {loading: true}
      })
      const res = yield call(API.addTerm, payload);
      if (res.code === 0) {
        message.success('OK');
        yield put({
          type: 'getTermList',
        });
      } else {
        message.error(res.message);
      }
      yield put({
        type: 'save',
        payload: {loading: false}
      })
    },
    *delTerm({ payload }, { call, put }) {
      const res = yield call(API.delTerm, payload);
      if (res.code === 0) {
        message.success('OK');
        yield put({
          type: 'getTermList',
        });
      } else {
        message.error(res.message);
      }
    },
    *editTerm({ payload }, { call, put }) {
      const res = yield call(API.editTerm, payload);
      if (res.code === 0) {
        message.success('OK');
        yield put({
          type: 'getTermList',
        });
      } else {
        message.error(res.message);
      }
    },
    *exportTerm({ payload }, { call }) {
      const res = yield call(API.exportTerm, payload);
      if (res.code === 0) {
        window.location.href = res.data.file_url
      } else {
        message.error(res.message);
      }
    },
  },
  reducers: {
    save(state, action) {
      return {
        ...state,
        ...action.payload,
      };
    },
  },
};
